import { useTranslation } from 'react-i18next';
import { Section } from '../layout';
import { TerminalWindow, TypewriterText } from '../common';

export function About() {
  const { t } = useTranslation();
  const bioLines = t('about.terminal.bio', { returnObjects: true }) as string[];

  return (
    <Section id="about" title={t('about.title')}>
      <div className="max-w-3xl mx-auto">
        <TerminalWindow title="about.sh">
          <div className="text-cyber-green mb-4">
            {t('about.terminal.whoami')}
          </div>
          <div className="text-cyber-text">
            <TypewriterText
              text={bioLines}
              speed={20}
              delay={500}
              showCursor={true}
            />
          </div>
        </TerminalWindow>
      </div>
    </Section>
  );
}
